import { type GloveCommandBody, type MarkDisplayScreen } from './screens';

/**
 * MARK Display `display!` body (api 1.2) for a screen: the template and its
 * fields as written, the duration as `time_validity_duration` (0: until replaced).
 * https://docs.proglove.com/en/screen-templates.html
 */
export const renderMarkDisplay = ({ template, fields, durationMs }: MarkDisplayScreen): GloveCommandBody => ({
  api_version: '1.2',
  event_type: 'display!',
  time_validity_duration: durationMs ?? 0,
  display_template_id: template,
  display_fields: fields.map(({ header, text }, index) => ({
    display_field_id: index + 1,
    display_field_header: header ?? '',
    display_field_text: text,
  })),
});
